// If you don't have file-saver, install it: npm install file-saver
import { saveAs } from 'file-saver';
import { formatBigMonetaryValue } from '../../ideaNiv/Funcs';


export function getTodayString() {
  const d = new Date();
  const month = d.toLocaleString('en-US', { month: 'short' });
  const day = d.getDate();
  const year = d.getFullYear();
  return `${month}-${day}-${year}`;
}

const getValue = (obj: any, path?: string) => {
  if (!path) return "";
  const value = path.split(".").reduce((acc, key) => acc?.[key], obj);

  // Only treat ISO-like or numeric strings as dates
  if (
    value &&
    (Object.prototype.toString.call(value) === "[object Date]" ||
      (typeof value === "string" &&
        /^\d{4}-\d{2}-\d{2}(T.*)?$/.test(value))) // strict date format check
  ) {
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${mm}-${dd}-${yyyy}`;
    }
  }

  if (path === "owner.name" && !value) {
    return obj?.idea?.owner?.name || "";
  }

  if (path === "componentObj.name" && !value) {
    return obj?.idea?.componentObj?.name || "Unassigned";
  }

  if ((path === "company.arr" || path === "cxItem.amount" || path === "opportunity.amount") && value) {
    return formatBigMonetaryValue(value);
  }

  return value;
};

// Main function
export function downloadEvidencesToCSV({
  evidences,
  columns,
  filename,
}: {
  evidences: any[],
  columns: any[],
  filename?: string,
}) {
  // Filename
  const dateStr = getTodayString();
  const finalFilename = filename || `Evidences_${dateStr}.csv`;
  if (!evidences || evidences.length === 0) {
    console.warn('No evidences to export');
    return;
  }

  // Columns to include
  const evidenceColumns = columns.map(col => col.label);
  const combinedHeaderLine = evidenceColumns.join(',');

  // Evidence rows
  const evidenceRows = evidences.map(ev => {
    return columns.map(col => {
      const val = getValue(ev, col.accessor);
      if (val === undefined || val === null) return '';
      let v = String(val).replace(/"/g, '""');
      if (/[",\n]/.test(v)) v = `"${v}"`;
      return v;
    }).join(',');
  });

  // 6. Compose final CSV
  const csvContent = [
    combinedHeaderLine,
    ...evidenceRows
  ].join('\n');

  // 7. Download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, finalFilename);
} 